"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var service_service_1 = require("../../Services/service.service");
var image_attach_component_1 = require("../image-attach/image-attach.component");
var WickedApiClient_1 = require("../../api/WickedApiClient");
var EmojiHelper_1 = require("../../Helpers/EmojiHelper");
var compare_versions_component_1 = require("../../Cms/compare-versions/compare-versions.component");
var material_1 = require("@angular/material");
var forms_1 = require("@angular/forms");
var SendConversationMessageComponent = /** @class */ (function () {
    function SendConversationMessageComponent(service, matDialog) {
        this.service = service;
        this.matDialog = matDialog;
        this.captchaEnabled = false;
        this.nickVisible = false;
        this.acceptTermsEnable = false;
        this.isNotFirstMessage = false;
        this.msg = new forms_1.FormControl();
        this.nickname = new forms_1.FormControl();
        this.advImagesCount = 0;
        this._premiumAdvertisementMessages = false;
        this._isSpecialUser = null;
        this._currentContentCursorPosition = -1;
        this._submitInProgress = false;
        this.hideRequirement = true;
        this.submitClick = new core_1.EventEmitter();
        this.imagesIsUploaded = false;
        this.termsaccept = false;
        this._captchaResolvedFlag = false;
    }
    SendConversationMessageComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.currentConversation) {
            this.service.advService.getAdvertisementData(this.currentConversation.advertisementId).then(function (advGet) {
                var advertisement = advGet.adveristments[0];
                if (advertisement.userId == _this.service.userService.getUserId() && advertisement.isPremium) {
                    _this._premiumAdvertisementMessages = true;
                }
                if (advertisement.userId == _this.service.userService.getUserId() && advertisement.images.length > 0)
                    _this.advImagesCount = advertisement.images.length;
            });
        }
        this.msg.valueChanges.subscribe(function (val) {
            if (!_this.isSpecialUser && !_this.PremiumAdvertisementMessages) {
                _this.msg.patchValue(EmojiHelper_1.removeEmojis(val), { onlySelf: true, emitEvent: false, emitModelToViewChange: true });
            }
        });
        this.nickname.valueChanges.subscribe(function (val) {
            if (!_this.isSpecialUser && !_this.PremiumAdvertisementMessages) {
                _this.nickname.patchValue(EmojiHelper_1.removeEmojis(val), { onlySelf: true, emitEvent: false, emitModelToViewChange: true });
            }
        });
    };
    Object.defineProperty(SendConversationMessageComponent.prototype, "PremiumAdvertisementMessages", {
        get: function () {
            return this._premiumAdvertisementMessages;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SendConversationMessageComponent.prototype, "isSpecialUser", {
        get: function () {
            if (this._isSpecialUser == null) {
                this._isSpecialUser = this.service.userService.isDemo() || this.service.userService.isPremium() || this.service.userService.isAdmin();
            }
            return this._isSpecialUser;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SendConversationMessageComponent.prototype, "conversationMessageContent", {
        get: function () {
            if (this.msg.value == null) {
                return "";
            }
            return this.msg.value;
        },
        set: function (value) {
            if (!this.isSpecialUser && !this.PremiumAdvertisementMessages) {
                value = EmojiHelper_1.removeEmojis(value);
            }
            this.msg.patchValue(value, { onlySelf: true, emitEvent: false, emitModelToViewChange: true });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SendConversationMessageComponent.prototype, "nick", {
        get: function () {
            if (this.nickname.value == null) {
                return "";
            }
            return this.nickname.value;
        },
        set: function (value) {
            if (!this.isSpecialUser && !this.PremiumAdvertisementMessages) {
                value = EmojiHelper_1.removeEmojis(value);
            }
            this.nickname.patchValue(value, { onlySelf: true, emitEvent: false, emitModelToViewChange: true });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SendConversationMessageComponent.prototype, "submitInProgress", {
        get: function () {
            return this._submitInProgress;
        },
        set: function (value) {
            this._submitInProgress = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SendConversationMessageComponent.prototype, "submitDisabled", {
        get: function () {
            var content = this.conversationMessageContent;
            var contentValid = (content != null && true) && ("" != content.trim());
            var nickValid = !this.nickVisible || (this.nick != null && this.nick.trim() != "");
            return !(contentValid && nickValid);
        },
        enumerable: true,
        configurable: true
    });
    SendConversationMessageComponent.prototype.addContentEmoji = function (e) {
        var value = this.conversationMessageContent;
        if (!value) {
            value = "";
        }
        if (this._currentContentCursorPosition > -1 && value != "") {
            value = value.substring(0, this._currentContentCursorPosition) + " " + e.emoji.native + " " + value.substring(this._currentContentCursorPosition + 1, value.length);
        }
        else {
            value = e.emoji.native;
        }
        this.conversationMessageContent = value;
        console.log(e);
    };
    SendConversationMessageComponent.prototype.contentBlur = function (e) {
        if (e.target['selectionStart'] != null) {
            this._currentContentCursorPosition = e.target['selectionStart'];
        }
    };
    SendConversationMessageComponent.prototype.fireSubmitEvent = function ($event) {
        if (!this.acceptTermsEnable || this.termsaccept) {
            var nickValid = !this.nickVisible || this.nick.trim() != '';
            var contentValid = (this.conversationMessageContent.trim() != '');
            if (this.conversationMessageContent.trim().length < 4000) {
                if (((this.isNotFirstMessage && this.imagesIsUploaded) || contentValid) && nickValid && this.isCaptchaOk()) {
                    this.submitClick.emit(this);
                }
                else {
                    this.service.showError("Message form fields are invalid, fill them properly");
                    this.hideRequirement = false;
                }
            }
            else {
                this.service.showError("The maximum length of the message is 4000 characters");
            }
        }
        else {
            this.service.showError("Please accept the terms and conditions before sending");
        }
    };
    SendConversationMessageComponent.prototype.prepareMessageContent = function () {
        return this.conversationMessageContent;
    };
    SendConversationMessageComponent.prototype.prepareMessageParams = function () {
        return new SendMessageParameters(this.nick, this.prepareMessageContent(), this.imageAttachComponent.dtoImages());
    };
    SendConversationMessageComponent.prototype.updateMessage = function (text) {
        this.conversationMessageContent = text;
    };
    SendConversationMessageComponent.prototype.submitStart = function () {
        this.submitInProgress = true;
    };
    SendConversationMessageComponent.prototype.submitFinished = function () {
        this.imagesIsUploaded = false;
        this.submitInProgress = false;
    };
    SendConversationMessageComponent.prototype.clear = function () {
        this.conversationMessageContent = '';
        this.imageAttachComponent.clear();
    };
    SendConversationMessageComponent.prototype.setImagesIsUploaded = function (status) {
        this.imagesIsUploaded = status;
    };
    SendConversationMessageComponent.prototype.userImageConversationCount = function (userId) {
        var count = 0;
        if (this.currentConversation != null && this.currentConversation.messages != null) {
            this.currentConversation.messages.filter(function (m) { return m.senderId == userId; }).forEach(function (message) {
                if (message.images != null) {
                    count += message.images.length;
                }
            });
        }
        return count;
    };
    Object.defineProperty(SendConversationMessageComponent.prototype, "userMaxImagesLength", {
        get: function () {
            var maxImages = 1;
            maxImages -= this.userImageConversationCount(this.service.userService.getUserId());
            maxImages -= this.advImagesCount;
            return maxImages;
        },
        enumerable: true,
        configurable: true
    });
    SendConversationMessageComponent.prototype.showMaxAttachmentsExceeded = function () {
        this.showCompareVersions();
    };
    SendConversationMessageComponent.prototype.showCompareVersions = function () {
        var item = this.matDialog.open(compare_versions_component_1.CompareVersionsComponent, {
            width: "80%",
            height: "810px",
            panelClass: "CompareVersionsComponent-panel",
            data: {
                isPopup: true,
                title: "Upgrade To Premium to send unlimited pictures"
            }
        });
        item.componentInstance.isPopup = true;
    };
    SendConversationMessageComponent.prototype.getCaptchaResolvedFlag = function () {
        return this._captchaResolvedFlag;
    };
    SendConversationMessageComponent.prototype.setCaptchaResolvedFlag = function (value) {
        this._captchaResolvedFlag = value;
    };
    SendConversationMessageComponent.prototype.captchaResolved = function (captchaResponse) {
        this.setCaptchaResolvedFlag(true);
    };
    SendConversationMessageComponent.prototype.captchaAvailable = function () {
        return this.service.captchaService.getCurrentCaptchaKey() != "";
    };
    SendConversationMessageComponent.prototype.onCheckChange = function (e) {
        this.termsaccept = e.checked;
    };
    SendConversationMessageComponent.prototype.isCaptchaOk = function () {
        if (!this.captchaEnabled) {
            return true;
        }
        return this.captchaAvailable() && this._captchaResolvedFlag;
    };
    return SendConversationMessageComponent;
}());
exports.SendConversationMessageComponent = SendConversationMessageComponent;
var SendMessageParameters = /** @class */ (function () {
    function SendMessageParameters(nick, content, images) {
        if (images === void 0) { images = []; }
        this.content = content;
        this.images = images;
        this.nick = nick;
    }
    return SendMessageParameters;
}());
exports.SendMessageParameters = SendMessageParameters;
